import React from 'react';
import { Redirect } from 'react-router-dom';

const ResetPasswordPage: React.FC = () => {
  return <Redirect to='/forgot-password' />;
};

export default ResetPasswordPage;
